import { format } from "date-fns";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Badge,
  Button,
  Card,
  CardBody,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import {
  QuestionDifficulty,
  QuestionLevel,
  QuestionTopic,
  questionTypeMap,
  questionTypePicMap,
} from "../../constants/QuestionsBankConstants";
import {
  deleteQuestion,
  fetchQuestion,
  fetchQuestions,
  resetQuestion,
} from "../../store/questionBank/action";

const CardDisplay = ({
  selectedCardId,
  setSelectedCardId,
  setIsNewQuestion,
  handleEditClick,
}) => {
  const dispatch = useDispatch();
  const allQuestions = useSelector(
    (state) => state?.QuestionBankReducer?.questions
  );
  const question = useSelector((state) => state?.QuestionBankReducer?.question);

  const [dropdownOpen, setDropdownOpen] = useState({});
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  useEffect(() => {
    dispatch(fetchQuestions());
  }, []);

  useEffect(() => {
    if (selectedCardId) {
      dispatch(fetchQuestion({ id: selectedCardId }));
    }
  }, [selectedCardId]);

  const toggleDropdown = (id) => {
    setDropdownOpen((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  const handleCardClick = (id) => {
    setSelectedCardId(id);
    setIsNewQuestion(false);
  };

  const confirmDelete = () => {
    setDeleteModalOpen(true);
  };

  const handleDelete = () => {
    dispatch(deleteQuestion({ id: selectedCardId }));
    dispatch(resetQuestion());
    setSelectedCardId(null);
    setDeleteModalOpen(false);
  };

  return (
    <div
      className="d-flex flex-column gap-3"
      style={{
        maxHeight: "750px",
        overflowY: "auto",
      }}
    >
      {allQuestions.length === 0
        ? "No questions created yet."
        : allQuestions
            .filter((question) => !question.isDeleted)
            .reverse()
            .map((question) => (
              <Card
                key={question.id}
                className="my-1 mx-1"
                style={
                  selectedCardId === question.id
                    ? {
                        cursor: "pointer",
                        borderColor: "#3F88E4",
                        borderWidth: "2px",
                        borderStyle: "solid",
                      }
                    : {
                        cursor: "pointer",
                        borderColor: "#EAECF0",
                        borderWidth: "1px",
                        borderStyle: "solid",
                      }
                }
                onClick={() => handleCardClick(question.id)}
              >
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <Badge
                        color={QuestionTopic[question.topic]}
                        className="mx-1 my-2"
                      >
                        {question.topic}
                      </Badge>
                      <Badge
                        color={QuestionLevel[question.level]}
                        className="mx-1 my-2"
                      >
                        {question.level}
                      </Badge>
                      <Badge
                        color={QuestionDifficulty[question.difficulty]}
                        className="mx-1 my-2"
                      >
                        {question.difficulty}
                      </Badge>
                    </div>
                    <Dropdown
                      isOpen={dropdownOpen[question.id]}
                      toggle={() => toggleDropdown(question.id)}
                      className="ml-auto"
                    >
                      <DropdownToggle
                        className="form-control text-start mdi mdi-dots-vertical"
                        style={{
                          border: "none",
                          backgroundColor: "white",
                        }}
                      />
                      <DropdownMenu
                        style={{
                          border: "none",
                        }}
                      >
                        <DropdownItem
                          onClick={() => handleEditClick(question.id)}
                        >
                          Edit
                        </DropdownItem>
                        <DropdownItem onClick={confirmDelete}>
                          Delete
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  </div>
                  <h5>{question.questionTitle}</h5>
                  <span
                    className={questionTypePicMap[question.questiontype]}
                  ></span>
                  <span>{questionTypeMap[question.questiontype]}</span>
                  <span className="mx-1"> | </span>
                  <span className="mdi mdi-calendar-blank-outline"></span>
                  <span>
                    {format(new Date(question.createdAt), "MMM dd, yyyy")}
                  </span>
                  <span></span>
                  <span className="mx-1"> | </span>
                  <span className="mdi mdi-account-edit-outline"></span>
                  <span>{question.name}</span>
                </CardBody>
              </Card>
            ))}
      <Modal
        isOpen={deleteModalOpen}
        toggle={() => setDeleteModalOpen(false)}
        centered
        size="md"
      >
        <ModalHeader>Confirm Delete Question</ModalHeader>
        <ModalBody>Are you sure you want to delete this question?</ModalBody>
        <ModalFooter>
          <Button
            className="btn btn-light"
            onClick={() => setDeleteModalOpen(false)}
          >
            Cancel
          </Button>
          <Button className="btn btn-danger" onClick={handleDelete}>
            Delete
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default CardDisplay;
